import { ModalController } from '@ionic/angular';
import { Router } from '@angular/router';
import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { GlobalService } from 'src/app/services/global.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-model-inferencing-history',
  templateUrl: './model-inferencing-history.component.html',
  styleUrls: ['./model-inferencing-history.component.scss'],
})

export class ModelInferencingHistoryComponent implements OnInit {

  @Input() initiator:string = "";
  @Input() currentTextForHistory:string = "";
  historyData: any[] = [];
  
  constructor(private modalCtrl: ModalController,private apiService:ApiService,private router:Router,private globalService:GlobalService,private http: HttpClient) {
   

  }
  ngOnInit(){
    this.fetchHistory();
  }

  
  objectKeys(obj: any): string[] {
      return Object.keys(obj);
  }

  fetchHistory() {
      console.log("fetch the history");
      this.globalService.logoutLoading();
      

      this.apiService.getModelInferencingHistory(this.currentTextForHistory).subscribe(response => {
        console.log('All History for text:', response);

        if (!response) {
            console.error("No response from API");
            this.globalService.dismissLoading();
            return;
        }

        const inputText = this.currentTextForHistory;
        if (response[inputText]) {
            this.historyData = [
                { [inputText]: response[inputText] }
            ];
            console.log("HHH",this.historyData);
        } else {
            console.log("Input text not found in data");
            
        }
        this.globalService.dismissLoading();
        
        
      }, error => {
        console.error('Model Inferenced error:', error);
        this.globalService.dismissLoading();
      });
   

  }



  goToMenu() {
    this.router.navigate(['/menu']);
  }

  closeModal(target:string) {
    this.modalCtrl.dismiss(); 
   
  }


}

